import { render, staticRenderFns } from "./SVGEditor.vue?vue&type=template&id=e871674c&scoped=true"
import script from "./SVGEditor.vue?vue&type=script&lang=js"
export * from "./SVGEditor.vue?vue&type=script&lang=js"
import style0 from "./SVGEditor.vue?vue&type=style&index=0&id=e871674c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e871674c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e871674c')) {
      api.createRecord('e871674c', component.options)
    } else {
      api.reload('e871674c', component.options)
    }
    module.hot.accept("./SVGEditor.vue?vue&type=template&id=e871674c&scoped=true", function () {
      api.rerender('e871674c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/svg-editor/SVGEditor.vue"
export default component.exports